export default __webpack_public_path__ + "static/media/homepage_slide1.5fe1983e.webp";